import React, { useMemo } from 'react';
import Translation from '@s/Translation';
import FocusTrap from '@s/FocusTrap';
import { setCheckoutOverlay } from '@/actions/ui';
import { useDispatch, useSelector } from 'react-redux';
import { getXssFilter } from 'checkout/helpers/helpers';
import { getMainEvent } from '../../../selectors/event';


export const PickerWithDetailsMain = ({ children, bannerImage }) => {
  const dispatch = useDispatch();

  const { listings } = useSelector((state) => state.ui.uiConfig);
  const event = useSelector(getMainEvent);

  const { name, time, location, content, useEventContent, heading } = listings;

  const onClose = () => {
    dispatch(setCheckoutOverlay(false));
  };

  const description = useMemo(() => {
    const desc = useEventContent !== 'undefined' && !useEventContent ? content : event?.event?.description || '';

    return getXssFilter().process(desc);
  }, [content, useEventContent, event]);

  // In case if description is empty it might have an empty p tag
  const isEmptyDescription = !description || description === '<p></p>';

  const title = useMemo(() => {
    return heading || <Translation>{'checkout__event_details'}</Translation>;
  }, [heading]);

  return (
    <FocusTrap fallback=".picker-with-details-wrap">
      <div className="picker-with-details-wrap" aria-modal="true" tabIndex="-1">
        <div className="details-banner">
          <img src={bannerImage} />
          <button className="button--close" onClick={onClose}>
            <i className="icon-close" aria-hidden="true"></i>
            <span className="sr-only">Close</span>
          </button>
        </div>
        <div className="picker-with-details__content">
          <div className="picker-with-details__info">
            <h1 className="info__name">{name}</h1>
            <div className="info__general">
              <p>{time}</p>
              <p>{location}</p>
            </div>
            <div className="picker-with-details__picker--mobile">
              <h2 className="picker__header">
                <Translation>{'checkout__get_tickets'}</Translation>
              </h2>
              {children}
            </div>
            {!isEmptyDescription && (
              <div className="info__description">
                <h2>{title}</h2>
                <div
                  className="info__rich-content"
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
              </div>
            )}
          </div>
          <div className="picker-with-details__picker">
            <h2 className="picker__header">
              <Translation>{'checkout__get_tickets'}</Translation>
            </h2>
            {children}
          </div>
        </div>
      </div>
    </FocusTrap>
  );
};
